import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FormContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.common.white,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.grey[200]}`,
  marginBottom: theme.spacing(2),
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
}));

export const FormTitle = styled('p')(({ theme }) => ({
  margin: 0,
  marginBottom: '0.75rem',
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '130%',
  color: theme.palette.grey[900],
}));
